module.exports = __webpack_public_path__ + "img/mastercard.11e45411.svg";